var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfNextPage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20689 6.16683L1.4367 1.51521C0.89907 1.15522 0.458252 1.41933 0.458252 2.10265V11.1343C0.458252 11.8157 0.89907 12.0798 1.4367 11.7217L8.20689 7.0682C8.20689 7.0682 8.46912 6.88116 8.46912 6.61893C8.46912 6.35575 8.20689 6.16683 8.20689 6.16683ZM9.85737 0.978516H10.7973C11.3171 0.978516 11.7372 1.02363 11.7372 1.54246V11.6935C11.7372 12.2123 11.3171 12.2575 10.7973 12.2575H9.85737C9.3376 12.2575 8.91746 12.2123 8.91746 11.6935V1.54246C8.91746 1.02363 9.3376 0.978516 9.85737 0.978516Z",
    fill: "#00495F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfNextPage);
export default __webpack_public_path__ + "static/media/pdfNextPage.1f4dd45debaac928488ff7875d89ec90.svg";
export { ForwardRef as ReactComponent };